import React from "react";
import PageBuilder from "../../components/PageBuilder/PageBuilder";
import { useSanityContent } from "../../hooks/useSanityContent";
import { PAGE_QUERY } from "../../sanity/queries";

const fallbackSections = [
  {
    _type: "heroAlternative",
    title: "Corporate Immigration Services",
    description: "As a solutions and services provider our prime objective in our Immigration Services - to make entering, working, and living in Liberia a seamless and pains free process.\n\nAt all times we will adhere to our core values – trustworthy, reliability and professionalism.",
    image: "/immigration_support.jpg",
  },
  {
    _type: "alternatingImageText",
    sections: [
      {
        title: "Immigration Documentation",
        description: "In collaboration with relevant government agencies and ministries we can facilitate all your applications for Visa on Arrival (VOA), Resident Permits, Work Permits, and the related applications such as Multi-entry Permits and the renewal of Permits; in a timely and efficient manner.",
        image: "/documents.jpg",
        imageAlt: "Project Management Office dashboard and team collaboration",
      },
      {
        title: "Dedicated Executive Support",
        description: "We will provide your organisation with a dedicated executive who will be responsible for your company and your employees requirements; including receiving you at the airport and hand delivery of all confidential and personal documents.",
        image: "/it_support.jpg",
        imageAlt: "Project audit analysis and reporting",
      },
    ],
  },
  { _type: "contactSection" },
];

export default function Immigration() {
  const { data } = useSanityContent(PAGE_QUERY("immigration"), { sections: fallbackSections });
  return <PageBuilder sections={data.sections} />;
}
